// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-09fb9524] .btn{min-width:2.7rem !important}[data-v-09fb9524] .btn:focus{box-shadow:none !important}", ""]);
// Exports
module.exports = exports;
